import { render, staticRenderFns } from "./vdo.vue?vue&type=template&id=2a548a55&scoped=true&"
import script from "./vdo.vue?vue&type=script&lang=js&"
export * from "./vdo.vue?vue&type=script&lang=js&"
import style0 from "./vdo.vue?vue&type=style&index=0&id=2a548a55&rel=stylesheet%2Fscss&lang=scss&scoped=true&"
import style1 from "./vdo.vue?vue&type=style&index=1&id=2a548a55&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a548a55",
  null
  
)

export default component.exports